import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GenericErrorContainer } from "../../routes";

interface Props {
  children: React.ReactNode;
}

export const ErrorBoundary: React.FC<Props> = ({ children }) => {
  const [error, setError] = useState<Error | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleError = (ev: ErrorEvent): void => {
      const err = new Error(ev.message);
      setError(err);
    };

    window.addEventListener("error", handleError);

    return () => {
      window.removeEventListener("error", handleError);
    };
  }, []);

  useEffect(() => {
    if (error) {
      window.location.reload();
    }
  }, [error, navigate]);

  if (error) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return <GenericErrorContainer status={(error as any).status} />;
  }

  return children;
};
